const AdminFreelancers = () => {
  return (
    <div>
      <h1>Admin Freelancers</h1>
    </div>
  );
}

export default AdminFreelancers;